import { Component, OnInit, Inject } from "@angular/core";
import {
  MatInputModule,
  MatFormFieldModule,
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material";
import { SessionStateService } from "../../../core/services/session-state.service";
import { environment } from "../../../../environments/environment";
import { ProfileService } from "../../../entities/profile/profile.service";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-privacy-policy-dialog",
  templateUrl: "./privacy-policy-dialog.component.html",
  styleUrls: ["./privacy-policy-dialog.component.scss"],
})
export class PrivacyPolicyDialogComponent {
  acceptPrivacyPolicyCheckbox: boolean = false;
  language: string;
  loading: boolean = false;
  loadingAnimationConfig = {
    backdropBackgroundColour: "rgba(0, 0, 0, 0)",
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<PrivacyPolicyDialogComponent>,
    private sessionStateService: SessionStateService,
    private profileService: ProfileService,
    private router: Router,
    private cookiesService: CookieService
  ) {
    // Since at this moment user is not logged in yet, language used is the browser language
    const browserLanguage = navigator.language;
    if (browserLanguage.startsWith("pt")) {
      this.language = "PT";
    } else if (browserLanguage.startsWith("es")) {
      this.language = "ES";
    } else {
      this.language = "EN";
    }
    dialogRef.disableClose = true;
  }

  showPrivacyPolicy(): void {
    if (this.language === "EN") {
      window.open(
        "https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/Privacy+Policy/Apps/Privacy+Policy_EN.pdf"
      );
    } else if (this.language === "PT") {
      window.open(
        "https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/Privacy+Policy/Apps/Privacy+Policy_PT.pdf"
      );
    } else if (this.language === "ES") {
      window.open(
        "https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/Privacy+Policy/Apps/Privacy+Policy_ES.pdf"
      );
    } else {
      // Default
      window.open(
        "https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/Privacy+Policy/Apps/Privacy+Policy_EN.pdf"
      );
    }
  }

  acceptPrivacyPolicy(): void {
    this.loading = true;

    this.profileService
      .acceptPrivacyPolicy()
      .finally(() => {
        this.loading = false;
      })
      .catch(() => {
        return Observable.empty();
      })
      .subscribe(() => {
        this.dialogRef.close();
        if (
          this.cookiesService.get("redirectUrl") &&
          this.cookiesService.get("redirectUrl") !== "null"
        ) {
          this.router.navigateByUrl(this.cookiesService.get("redirectUrl"));
          this.cookiesService.set("redirectUrl", null);
        } else {
          this.router.navigate(["/"]);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/privacy-policy-dialog/privacy-policy-dialog.component.ts